import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import {
  BoxDanger,
  BoxInfo,
  MnemoCallout,
  MnemoLoading,
  MSection,
  SupportoTecnicoLive,
  Title,
} from "components/misc";

import {
  dateHelper,
  learningService,
  lessonTrainingService,
  networkErrorHelper,
} from "libs";
import { LESSONTRAINING_MODE, ROUTES } from "const";

import { Icon, Button } from "design-react-kit";

class CourseLessonTrainingScheduleAll extends Component {
  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    trainingType: "",
    course: {},
    userCourse: {},
    trainings: [],
    liveClass: null,
    isOnline: false
  };

  componentDidMount() {
    const { rCode, trainingType } = this.props.match.params;
    this.setState({ rCode, trainingType });
    this.loadUserCourse(rCode, trainingType);
  }

  loadUserCourse(rCode, trainingType) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemote(course.id, userCourse.registrationCode, trainingType);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemote(courseId, rCode, trainingType) {
    lessonTrainingService
      .MyScheduleTraining(courseId, rCode, trainingType)
      .then(({ data }) => {
        console.log(data);

        let isOnline = false;
        if (data.payload?.lessonTrainings && data.payload.lessonTrainings.length > 0) {
          isOnline = data.payload.lessonTrainings.some((training) => training.mode === LESSONTRAINING_MODE.ONLINE);
        }
        this.setState({
          loading: false,
          trainings: data.payload.lessonTrainings,
          liveClass: data.payload.lessonTrainingClasses,
          isOnline: isOnline
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  showLinkIdMeet(training) {
    let show = false;

    if (training.idMeet && training.date && training.hourStart) {
      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(training.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(training.hourStart);

        // il link si attiva da 60 minuti prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 60 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  showLinkUrlRegister(training) {
    let show = false;

    if (training.urlRegister && training.date && training.hourStart) {
      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(training.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(training.hourStart);

        // il link si attiva da 2 ore prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 180 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  goDetail = (trainingId) => {
    const { rCode } = this.state;
    window.location = `${ROUTES.COURSE_LESSONTRAINING_DETAIL}/${rCode}/${trainingId}`;
  };

  goActivity = (training) => {
    const { rCode } = this.state;
    window.location = `${ROUTES.COURSE_LESSON_ACTIVITY}/training/${training.location}/${training.id}/${rCode}`;
  };

  openLink = (link) => {
    window.open(link, "_blank");
  };

  getLocation = (training) => {
    let location = "";
    const { userCourse } = this.state;
    switch (training.mode) {
      case LESSONTRAINING_MODE.ONLINE:
        location = "ONLINE";
        break;

      case LESSONTRAINING_MODE.PRESENZA:
        // verify if the lcoation exists by region
        if (training.location && userCourse.pluginConfig?.region) {
          const tLocaltion = JSON.parse(training.location);
          location = tLocaltion[userCourse.pluginConfig.region.toUpperCase()];
        } else {
          // show the first location if the region is not set
          const tLocaltion = JSON.parse(training.location);
          const keys = Object.keys(tLocaltion);
          location = tLocaltion[keys[0]];
        }
        break;

      case LESSONTRAINING_MODE.ATTIVITA:
        location = "";
        break;

      default:
        location = "";
        break;
    }

    return location;
  };

  renderTrainings(trainings, userCourse) {
    let creditRecognition = false;
    if (userCourse && userCourse.creditRecognition) {
      creditRecognition = userCourse.creditRecognition;
    }

    return (
      <MSection className="m-2">
        {trainings.length > 0 ? (
          <>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Data</th>
                  <th scope="col">Ora inizio</th>
                  <th scope="col">Modalità erogazione</th>
                  <th scope="col">{this.state.trainingType === "laboratorio" ? "Laboratorio" : "Argomento"}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {trainings.map((training, i) => (
                  <tr key={i}>
                    <td>
                      {training.date ? dateHelper.toITDate(training.date) : ""}
                    </td>
                    <td>
                      {training.hourStart
                        ? dateHelper.toShortTime(training.hourStart)
                        : ""}
                    </td>
                    <td>{this.getLocation(training)}</td>
                    <td>{training.subject}</td>
                    <td>
                      {creditRecognition &&
                        training.creditRecognition &&
                        training.creditRecognition.includes(creditRecognition) ? (
                        <>
                          <p className="btn btn-outline-primary m-1">
                            Attività da non frequentare a seguito di
                            riconoscimento
                          </p>
                        </>
                      ) : (
                        <>
                          {training.mode === LESSONTRAINING_MODE.ONLINE && (
                            <>
                              {this.showLinkUrlRegister(training) && (
                                <Button
                                  color="primary m-1"
                                  outline
                                  onClick={(e) => {
                                    this.openLink(training.urlRegister);
                                  }}
                                >
                                  Registrati
                                </Button>
                              )}
                              {this.showLinkIdMeet(training) && (
                                <>
                                  <Button
                                    color="primary m-1 btn-block"
                                    outline
                                    onClick={(e) => {
                                      this.openLink(training.idMeet);
                                    }}
                                  >
                                    Partecipa
                                    {parseInt(training.myRegistrationIDWebex) >
                                      0 && (
                                        <div>
                                          <small className="text-muted">
                                            codice registrazione:{" "}
                                            {training.myRegistrationIDWebex}
                                          </small>
                                        </div>
                                      )}
                                  </Button>
                                </>
                              )}
                              {training.location ===
                                LESSONTRAINING_MODE.ONLINE && (
                                  <Button
                                    id="radio"
                                    color="primary bg-dark m-1 btn-block"
                                    onClick={(e) => {
                                      this.goDetail(training.id);
                                    }}
                                  >
                                    Dettaglio
                                  </Button>
                                )}
                            </>
                          )}
                        </>
                      )}
                      {training.mode === LESSONTRAINING_MODE.PRESENZA && (
                        <Button
                          id="radio"
                          color="primary bg-dark m-1 btn-block"
                          onClick={(e) => {
                            this.goDetail(training.id);
                          }}
                        >
                          Dettaglio
                        </Button>
                      )}
                      {training.mode === LESSONTRAINING_MODE.ATTIVITA && training.location.length > 0 && (
                        <Button
                          id="radio"
                          color="primary bg-dark m-1 btn-block"
                          onClick={(e) => {
                            this.goActivity(training);
                          }}
                        >
                          Dettaglio
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {this.state.isOnline && (<>
              <MnemoCallout >
                <p>Non è consentito accedere all'attività trascorse quattro ore dal suo inizio.</p>
              </MnemoCallout>
              <SupportoTecnicoLive courseCode={userCourse.courseCode} />
            </>
            )}

            <MnemoCallout>
              <p>Calendario in continuo aggiornamento.</p>
            </MnemoCallout>
          </>
        ) : (
          <BoxInfo className="m-2">
            <p>Pagina in aggiornamento. Calendario a breve disponibile.</p>
          </BoxInfo>
        )}
      </MSection>
    );
  }

  getTitle(trainingType) {

    let title = "Tirocinio Indiretto";
    if (trainingType === "laboratorio") title = "Laboratori";
    if (trainingType === "tic") title = "Nuove Tecnologie per l'Apprendimento - TIC";
    return title;
  }

  render() {
    const { loading, loadingError, trainings, rCode, userCourse, trainingType } = this.state;

    const title = this.getTitle(trainingType);

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta. <SupportoTecnicoLive courseCode={userCourse.courseCode} />
        </BoxDanger>
      );

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>{title}</Title>
        {this.renderTrainings(trainings, userCourse)}
      </>
    );
  }
}

export default withRouter(CourseLessonTrainingScheduleAll);
